var icon = require('vue-svgicon')
icon.register({
  'ks-icon-contact-email': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M111 22H17.67a9.34 9.34 0 0 0-9.34 9.33v65.34a9.34 9.34 0 0 0 9.34 9.33H111a9.33 9.33 0 0 0 9.33-9.33V31.33A9.33 9.33 0 0 0 111 22M45.67 36a14 14 0 1 1-14 14 14 14 0 0 1 14-14m28 56h-56v-4.67c0-9.33 18.66-14.46 28-14.46s28 5.13 28 14.46V92m31.16-46.28v-5.17L89.31 50.89 73.79 40.55v5.17l15.52 10.35 15.52-10.35m0-10.34a5.17 5.17 0 0 1 5.17 5.17v23.28a5.18 5.18 0 0 1-5.17 5.17h-31a5.17 5.17 0 0 1-5.17-5.17V40.55a5.16 5.16 0 0 1 5.17-5.17h31"/>'
  }
})
